<template>
  <div class="available-operation-container">
    <h5>{{ $t('documentation.api.availableOperations.title') }}</h5>
    <ul class="operations-list">
      <li v-for="(tagOperation, index) in operations" :key="index" class="operation-sublist">
        <AvailableOperationSubSection
          :id="tagOperation.id"
          :method="tagOperation.method"
          :summary="tagOperation.summary"
        />
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { PropType } from 'vue';
import { OperationObject } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import AvailableOperationSubSection from '@/components/api/content/common/AvailableOperationSubSection.vue';

defineProps({
  operations: { type: Array as PropType<OperationObject[]>, required: true },
});
</script>
<style scoped lang="scss">
.available-operation-container {
  padding: 0;
}

.operations-list {
  list-style-type: none;
  margin-bottom: 0;
  padding: 0;
}
.operation-sublist {
  margin-bottom: 5px;
  list-style-type: none !important;
}
h5 {
  font-size: 15px !important;
  margin: 16px 0 !important;
}
</style>
